import * as Yup from "yup";
import { KeyValueMap } from "../../../redux/slices/appState/models";
import { BulkEditSearchParticipantFormKey } from "./Model";

export const BulkEditProgramSearchParticipantSchema = (
  commonValidationMessages: KeyValueMap,
) =>
  Yup.object().shape({
    [BulkEditSearchParticipantFormKey.clientId]: Yup.string().required(
      commonValidationMessages.requiredValidation,
    ),
    [BulkEditSearchParticipantFormKey.clientName]: Yup.string().default(""),
    [BulkEditSearchParticipantFormKey.deliveryCountry]: Yup.array().default([]),
    [BulkEditSearchParticipantFormKey.productLine]: Yup.array().default([]),
    [BulkEditSearchParticipantFormKey.programTemplate]:
      Yup.string().default(""),
    [BulkEditSearchParticipantFormKey.participantStatus]:
      Yup.string().default(""),
  });
